import { QuestionnaireFormProps } from '@getpopsure/qnr-framework';
import routes from 'constants/routes';
import dayjs from 'dayjs';
import { Policy } from 'models/policies';
import { generatePath, Link } from 'react-router-dom';

import { AdjustPolicyAnswers } from '../../models';
import success from './assets/success.svg';
import styles from './Success.module.scss';

type SuccessProps<Questionnaire extends AdjustPolicyAnswers> = {
  title: string;
  description?: string;
  buttonCaption?: string;
  configuration: {
    policy: Policy;
  };
} & QuestionnaireFormProps<Questionnaire>;

export const Success = <Questionnaire extends AdjustPolicyAnswers>({
  title,
  description,
  buttonCaption,
  configuration,
  questionnaireAnswers: { startDate },
}: SuccessProps<Questionnaire>) => {
  const formattedStartDate = dayjs(startDate).format('DD MMM YYYY');
  const descriptionWithStartDate = description?.replace(
    '{{startDate}}',
    formattedStartDate
  );

  return (
    <div
      className={`${styles.container} p-container d-flex fd-column ai-center jc-center px16 wmx8`}
    >
      <img src={success} className="wmn2" alt="" />
      <h2 className="p-h1 ta-center mt16">{title}</h2>

      {descriptionWithStartDate && (
        <h4 className="p-p mt24 ta-center">{descriptionWithStartDate}</h4>
      )}

      <div className="d-flex fd-column gap16 mt24 ai-center jc-center">
        <Link
          to={generatePath(routes.me.policies.detail.path, {
            policyId: configuration.policy.id,
          })}
          className="p-btn--primary wmn3"
        >
          {buttonCaption}
        </Link>
      </div>
    </div>
  );
};
